import { Icon, PointExpression } from 'leaflet';
// import BlueIcon from "../assets/marker-icon-blue.png";
// import GreenIcon from "../assets/marker-icon-green.png";
import CurrentIconSym from "../assets/marker-icon-current-sym.png";
import CurrentIcon from "../assets/marker-icon-current.png";
import LevelIconGreenHighlight from "../assets/marker-icon-level-green-highlighted.png";
import LevelIconGreen from "../assets/marker-icon-level-green.png";
import LevelIconSym from "../assets/marker-icon-level-sym.png";
import LevelIcon from "../assets/marker-icon-level.png";
import PurpleIcon from "../assets/marker-icon-purple.png";
import RedIcon from "../assets/marker-icon-red.png";
import WaveIconBlue from "../assets/marker-icon-wave-blue.png";
import WaveIconGreenHighlight from "../assets/marker-icon-wave-green-highlighted.png";
import WaveIconGreen from "../assets/marker-icon-wave-green.png";
import WaveIconSym from "../assets/marker-icon-wave-sym.png";
import WaveIcon from "../assets/marker-icon-wave.png";
import WindIconBlue from "../assets/marker-icon-wind-blue.png";
import WindIconGreenHighlight from "../assets/marker-icon-wind-green-highlighted.png";
import WindIconGreen from "../assets/marker-icon-wind-green.png";
import WindIconSym from "../assets/marker-icon-wind-sym.png";
import WindIcon from "../assets/marker-icon-wind.png";
import YellowIcon from "../assets/marker-icon-yellow.png";
import PlusIcon from "../assets/marker-plus.png";
import ShadowIcon from "../assets/marker-shadow.png";

// Alternative colours
import AquaIcon from "../assets/marker-icon-aqua.png";
import GreenTwoIcon from "../assets/marker-icon-green-two.png";
// import OrangeIcon from "../assets/marker-icon-orange.png";
// import RedTwoIcon from "../assets/marker-icon-red-two.png.png";

export type ColourOptions = keyof typeof icons | 'other' | 'plus'

export const icons = {
  red: RedIcon,
  green: GreenTwoIcon,
  yellow: YellowIcon,
  blue: AquaIcon,
  purple: PurpleIcon,
  wave: WaveIcon,
  current: CurrentIcon,
  wind: WindIcon,
  waveblue: WaveIconBlue,
  windblue: WindIconBlue,
  wavegreen: WaveIconGreen,
  windgreen: WindIconGreen,
  wavegreenhighlight: WaveIconGreenHighlight,
  windgreenhighlight: WindIconGreenHighlight,
  waterlevel: LevelIcon,
  plus: PlusIcon,
  other: PlusIcon,
  levelgreen: LevelIconGreen,
  levelgreenhighlight: LevelIconGreenHighlight,
  waterlevelSym: LevelIconSym,
  waveSym: WaveIconSym,
  currentSym: CurrentIconSym,
  windSym: WindIconSym,
}
export const getMarkerIcon = (color: ColourOptions) => {
  return Object.prototype.hasOwnProperty.call(icons, color) ? icons[color] : icons.blue
}

export const createMarkerIcon = (color: ColourOptions) => {
  let iconSize: PointExpression = [42,42]
  let iconAnchor: PointExpression = [21, 42]
  const popupAnchor: PointExpression = [0, -40]
  if (color === 'wavegreenhighlight' 
    || color === 'windgreenhighlight' 
    || color === 'wavegreen' 
    || color === 'levelgreenhighlight' 
    || color === 'levelgreen' 
    || color === 'windgreen'
  ) {
    iconSize = [40,73]
    iconAnchor = [20, 73]
  }
  // if (color === 'wave' || color === 'wind') {
  //   popupAnchor = [0, -40]
  // }
  return new Icon({
    iconUrl: getMarkerIcon(color),
    iconSize,
    iconAnchor,
    popupAnchor,
    shadowUrl: ShadowIcon,
    shadowSize: [52,52],
    shadowAnchor: [16, 52]
  })
}